export default __webpack_public_path__ + "media/images/meals/morning-4e9724087a2f0596db6e2b54a93156d9.png";